import Cookies from 'js-cookie';
import { generateUUID } from '@cbhq/client-analytics';

const COOKIE_DEVICE_ID = 'coinbase_device_id';
const TWENTY_YEARS_AS_MS = 630_720_000_000;

export function getDeviceId() {
  let id = Cookies.get(COOKIE_DEVICE_ID);
  if (!id) {
    id = generateUUID();
    Cookies.set(COOKIE_DEVICE_ID, id, {
      expires: new Date(Date.now() + TWENTY_YEARS_AS_MS),
    });
  }
  return id;
}
